import {
  AbstractControl,
  UntypedFormArray,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import * as dayjs from 'dayjs';
import { DateObjectToYYYMMDDstring } from 'src/app/product-capture/utils/convert-date-object-to-yyyy-mm-dd-string';

export function countriesOfOfferDatesValidator(
  subStartDate: string,
  subEndDate: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Check if control has subscription set to true
    let subscriptionControl = control.get('subscription');
    if (!subscriptionControl || !subscriptionControl.value) {
      return null;
    }

    const subscriptions = control.get('subscriptions') as UntypedFormArray;

    subscriptions.controls.forEach((subControl) => {
      let subStartDateControl = subControl.get(subStartDate);
      let subEndDateControl = subControl.get(subEndDate);

      if (subStartDateControl.value && subEndDateControl.value) {
        let startDateStr = DateObjectToYYYMMDDstring(subStartDateControl.value);
        let startDate = dayjs(startDateStr);
        let endDateStr = DateObjectToYYYMMDDstring(subEndDateControl.value);
        let endDate = dayjs(endDateStr);
        let startIsBeforeEnd = startDate.isBefore(endDate);

        if (!startIsBeforeEnd) {
          subStartDateControl.setErrors({
            incorrect: true,
            message: 'Sub Start Date should be before Sub End Date',
          });
          subEndDateControl.setErrors({
            incorrect: true,
            message: 'Sub End Date should be after Sub Start Date',
          });
        } else {
          subStartDateControl.setErrors(null);
          subEndDateControl.setErrors(null);
        }
      }
    });

    return null;
  };
}
